import { EVENT_CLICK_PARENT_PRODUCT } from '~~/constants/googleTagManager';
import type { EcommerceClickParentProduct } from '~~/types/integrations/tagManager/TagClickParentProduct';

export const buildClickParentProductTags = (parentProductSku: string, accessoryId: string) => ({
  event: EVENT_CLICK_PARENT_PRODUCT,
  ecommerce: {
    detail: {
      items: {
        parent_id: parentProductSku,
        accessory_product_id: accessoryId,
      },
    },
  } as EcommerceClickParentProduct,
});
